import { render, staticRenderFns } from "./wateragain.vue?vue&type=template&id=3cd31cdb&scoped=true&"
import script from "./wateragain.vue?vue&type=script&lang=js&"
export * from "./wateragain.vue?vue&type=script&lang=js&"
import style0 from "./wateragain.vue?vue&type=style&index=0&id=3cd31cdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd31cdb",
  null
  
)

export default component.exports